import Stack from '@mui/material/Stack';
import Popper from '@mui/material/Popper';
import { styled } from '@mui/material/styles';

export const AvatarWrapper = styled('div')`
  position: relative;
  overflow: hidden;
  cursor: pointer;
  flex: 0 0 40%;
  height: 100%;

  &:hover > div:first-of-type {
    opacity: 1;
  }
`;

export const EditHover = styled('div')<{ $isSm: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);

  border-radius: ${({ $isSm }) => ($isSm ? '24px 24px 0 0' : '24px 0 0 24px')};

  display: flex;
  justify-content: center;
  align-items: center;

  opacity: 0;
  transition: opacity 0.3s ease-in-out;
`;

export const Avatar = styled('div')<{ $bgColor: string; $isSm: boolean }>`
  width: 100%;
  height: 100%;
  min-height: 150px;
  border-radius: ${({ $isSm }) => ($isSm ? '24px 24px 0 0' : '24px 0 0 24px')};
  background-color: ${({ $bgColor }) => $bgColor};
  color: white;
  display: flex;
  font-size: 48px;
  justify-content: center;
  align-items: center;
`;

export const AvatarPicture = styled('img')<{ $isSm: boolean }>`
  border-radius: ${({ $isSm }) => ($isSm ? '24px 24px 0 0' : '24px 0 0 24px')};
  object-fit: cover;
  width: 100%;
  height: 100%;
`;

export const AvatarPopper = styled(Popper)`
  background-color: linear-gradient(
    145deg,
    rgba(42, 52, 77, 0.85) 0%,
    rgba(0, 207, 255, 0.12) 100%
  );

  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid ${({ theme }) => theme.palette.fixed.white};
  border-radius: 8px;
  z-index: 1300;
`;

export const PopperStack = styled(Stack)`
  color: ${({ theme }) => theme.palette.fixed.white};
  padding: 8px;
  cursor: pointer;
  :hover {
    background-color: ${({ theme }) => theme.palette.grey['05']};
  }
  flex-direction: row;
`;
